import { render, staticRenderFns } from "./AppHeaderPopup.vue?vue&type=template&id=5cf7a4ec&scoped=true&"
import script from "./AppHeaderPopup.vue?vue&type=script&lang=js&"
export * from "./AppHeaderPopup.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderPopup.vue?vue&type=style&index=0&id=5cf7a4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7a4ec",
  null
  
)

export default component.exports